import api from '../config/api';

// Connector API services
export const connectorService = {
  // Get available source definitions
  getSourceDefinitions: async () => {
    const response = await api.get('/api/connectors/sources/definitions');
    return response.data;
  },

  // Get available destination definitions
  getDestinationDefinitions: async () => {
    const response = await api.get('/api/connectors/destinations/definitions');
    return response.data;
  },

  // Sources
  getSources: async () => {
    const response = await api.get('/api/connectors/sources');
    return response.data;
  },

  getSourceById: async (id) => {
    const response = await api.get(`/api/connectors/sources/${id}`);
    return response.data;
  },

  createSource: async (sourceData) => {
    const response = await api.post('/api/connectors/sources', sourceData);
    return response.data;
  },

  updateSource: async (id, sourceData) => {
    const response = await api.put(`/api/connectors/sources/${id}`, sourceData);
    return response.data;
  },

  deleteSource: async (id) => {
    const response = await api.delete(`/api/connectors/sources/${id}`);
    return response.data;
  },

  getSourceSchema: async (id) => {
    const response = await api.get(`/api/connectors/sources/${id}/schema`);
    return response.data;
  },

  // Destinations
  getDestinations: async () => {
    const response = await api.get('/api/connectors/destinations');
    return response.data;
  },

  getDestinationById: async (id) => {
    const response = await api.get(`/api/connectors/destinations/${id}`);
    return response.data;
  },

  createDestination: async (destinationData) => {
    const response = await api.post('/api/connectors/destinations', destinationData);
    return response.data;
  },

  updateDestination: async (id, destinationData) => {
    const response = await api.put(`/api/connectors/destinations/${id}`, destinationData);
    return response.data;
  },

  deleteDestination: async (id) => {
    const response = await api.delete(`/api/connectors/destinations/${id}`);
    return response.data;
  },

  // Platforms
  getPlatforms: async () => {
    const response = await api.get('/api/connectors/platforms');
    return response.data;
  },

  // Connectors (main API)
  createConnector: async (connectorData) => {
    const response = await api.post('/api/connectors/create', connectorData);
    return response.data;
  },

  // Connections
  getConnections: async () => {
    const response = await api.get('/api/connectors/connections');
    return response.data;
  },

  getConnectionById: async (id) => {
    const response = await api.get(`/api/connectors/connections/${id}`);
    return response.data;
  },

  createConnection: async (connectionData) => {
    const response = await api.post('/api/connectors/connections', connectionData);
    return response.data;
  },

  updateConnection: async (id, connectionData) => {
    const response = await api.put(`/api/connectors/connections/${id}`, connectionData);
    return response.data;
  },

  // Update connector (name, etc.)
  updateConnector: async (id, connectorData) => {
    const response = await api.put(`/api/connectors/connections/${id}`, connectorData);
    return response.data;
  },

  deleteConnection: async (id) => {
    const response = await api.delete(`/api/connectors/connections/${id}`);
    return response.data;
  },

  triggerSync: async (id) => {
    const response = await api.post(`/api/connectors/${id}/sync`);
    return response.data;
  },

  getSyncHistory: async (id) => {
    const response = await api.get(`/api/connectors/connections/${id}/sync-history`);
    return response.data;
  },
};

export default connectorService;
